import { LeadDetails,PreQualificationResponseType } from './../interfaces/prequalification-response.interface';
import { PreQualification, BuyNowLead, BuyNowLeadResponse } from './../interfaces/credit-application.interface';
import { Inject, Injectable } from '@angular/core';
import { DevModeService } from './dev-mode.service';
import { HttpClient } from '@angular/common/http';
import {
  IZipCodeRequest,
  IZipCodeResponse
} from '../interfaces/IZipCode.interface';
import { BehaviorSubject,Observable, of } from 'rxjs';
import { CREDITAPP_API_URLS, BANK_API } from '../../global';
import {
  ZipCodeResponseMock,
  CreditAppResponseMock
} from '../../tests/responses.mock';
import { delay, map, catchError } from 'rxjs/operators';
import { CreditApplication } from '../interfaces/credit-application.interface';
import { CreditApplicationRequestType } from '../interfaces/credit-application-request.interface';
import {
  CreditApplicationResponseType,
  CreditApplicationStatusTypeEnum,
  BankResponseType
} from '../interfaces/credit-application-response.interface';
import { NotificationsService } from '../services/notifications.service';
import { NotificationType } from '../interfaces/notification.interface';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { IConfig } from '../interfaces/config.interface';

@Injectable({
  providedIn: 'root'
})
export class CreditAppService {

  public CreditApplication: CreditApplication = {
    creditAppId: null,
    opptId: null,
    coBuyer: {
      relationshipToApplicant: null,
      personalInformation: {
        firstName: null,
        lastName: null,
        middleName: null,
        phoneNumber: null,
        emailAddress: null,
        currentAddress: {
          addressLine1: null,
          addressLine2: null,
          city: null,
          stateCode: null,
          postalCode: null,
          yearsAtAddress: null,
          monthsAtAddress: null
        },
        previousAddress: [],
        preQualAmount: null,
        sameAddresAsApplicant: false
      },
      financialInformation: {
        securityInformation: {
          dob: null,
          dobMonth: null,
          dobDate: null,
          dobYear: null,
          ssn: null,
          ssn1: null,
          ssn2: null,
          ssn3: null,
          verifySsn1: null,
          verifySsn2: null,
          verifySsn3: null
        },
        residenceInformation: {
          residenceType: null,
          monthlyMortgageAmount: null,
          mortgageCompany: null,
          yearsAtAddress: null,
          monthsAtAddress: null,
        },
        currentEmployer: {
          employmentStatus: null,
          jobType: null,
          employerName: null,
          jobTitle: null,
          phoneNumber: null,
          yearsAtEmployer: null,
          monthsAtEmployer: null,
          salary: null,
          frequency: null,
        },
        previousEmployer: {
          employmentStatus: null,
          jobType: null,
          employerName: null,
          jobTitle: null,
          phoneNumber: null,
          yearsAtEmployer: null,
          monthsAtEmployer: null,
          salary: null,
          frequency: null,
        },
        otherIncomeInformation: {
          otherIncomeType: null,
          frequency: null,
          explain: null,
          amount: null,
        },
        hasOtherIncome: false
      },
      educationalInformation: {},
      consentIndicator: true,
      authorizationConsent: false,
      initials: null
    },
    managerInitials: null,
    buyerFullName: '',
    coBuyerFullName: '',
    reasonForChange: null,
    shortForm: {
      disclaimers: null,
      personalInformation: {
        firstName: null,
        lastName: null,
        middleName: null,
        phoneNumber: null,
        emailAddress: null,
        dateOfBirth: null,
        ssn: null,
        income: null,
        monthlyMortgage: null,
        currentAddress: {
          addressLine1: null,
          addressLine2: null,
          city: null,
          stateCode: null,
          postalCode: null,
          yearsAtAddress: null,
          monthsAtAddress: null,
        },
        previousAddress: []
      },
      tradeInInfo: {
        applyTrade: false,
        applyTradeFullValue: false,
        applyTradeAmount: null,
        tradePayoff: null,
        tradeValue: null,
        missingTitle: false,
        openTradeDmvFees: null,
        inServiceDate: null,
        inceptionMiles: null
      },
      surveyQuestions: null,
      intendedUse: null,
      paymentOption: null,
      cashDown: null,
      vehicleInformation: {
        vin: null,
        year: null,
        make: null,
        model: null,
        trim: null,
        stockType: null,
        hyperionId: null,
        stockNo: null
      },
      qualificationTemplates: {
        qualified: null,
        notQualified: null,
      },
      enablePreQualification: false,
      dealParameters: {
        sceId: null,
        sceUserId: null,
        sceVehicleOfInterestId: null,
        userId: null,
        creditAppId: null,
        parentCreditAppId: null,
        opptId: null,
        opptVehicleId: null,
        creditShortFormId: null,
        creditFormId: null,
        tradeInVehicleId: null,
        paymentCalculatorId: null
      },
      userName: null,
      bookValue: null,
      vehiclePayment: null,
      viewType: null,
      siteId: null,
      microsoftLocaleId: null,
      isoLanguage: null,
      voiInceptionMiles: null,
      validationErrors: []
    },
    hasCoBuyer: false,
    buyerHasOtherIncome: false,
    buyerAuthorizationConsent: false,
    coBuyerHasOtherIncome: false,
    coBuyerAuthorizationConsent: false,
    sameAddresAsApplicant: false,
    regulationsConsent: false,
    managerConsent: false,
    buyerRegulationBConsent: false,
    coBuyerRegulationBConsent: false,
    communityPropertyConsent: false,
    step: 0,
    creditApplicationStatus: 'NotStarted',
    creditApplicationCompleted: false,
    siteId: 10000,
    microsoftLocaleId: 1033,
    sceId: null,
    sceUserId: null,
    sceVehicleOfInterestId: null,
    userId: null,
    buyer: {
      personalInformation: {
        firstName: null,
        lastName: null,
        middleName: null,
        phoneNumber: null,
        emailAddress: null,
        dateOfBirth: null,
        income: null,
        monthlyMortgage: null,
        currentAddress: {
          addressLine1: null,
          addressLine2: null,
          city: null,
          stateCode: null,
          postalCode: null,
          yearsAtAddress: null,
          monthsAtAddress: null,
        },
        previousAddress: []
      },
      financialInformation: {
        securityInformation: {
          dob: null,
          ssn: null,
          ssn1: null,
          ssn2: null,
          ssn3: null,
          dobMonth: null,
          dobDate: null,
          dobYear: null,
        },
        residenceInformation: {
          residenceType: null,
          monthlyMortgageAmount: null,
        },
        currentEmployer: {
          employmentStatus: null,
          jobType: null,
          employerName: null,
          jobTitle: null,
          phoneNumber: null,
          yearsAtEmployer: null,
          monthsAtEmployer: null,
          salary: null,
          frequency: null,
        },
        previousEmployer: {
          employmentStatus: null,
          jobType: null,
          employerName: null,
          jobTitle: null,
          phoneNumber: null,
          yearsAtEmployer: null,
          monthsAtEmployer: null,
          salary: null,
          frequency: null,
        },
        otherIncomeInformation: {
          amount: null,
          frequency: null,
          otherIncomeType: null,
        }
      },
      educationalInformation: null,
      consentIndicator: false,
      initials: null
    },
    voi: {
      vin: null,
      year: null,
      make: null,
      model: null,
      trim: null,
      stockType: null,
      hyperionId: null,
      chromeStyleId: null,
      isPrimary: false,
      stockNo: null,
      voiInceptionMiles: null,
      showVoiPreview: true,
      photo:
        null,
      ANPrice: null,
      InventoryStatus: null,
      Mileage: null,
    },
    disclaimers: {
      preQualAgreement: '',
      preQualifiedDisclaimer: '',
      notQualifedDisclaimer: '',
      buyerAuthorization:
        null,
      coBuyerAuthorization:
        null,
      buyerRegulationBDisclaimer: 'We intend to apply for joint credit',
      coBuyerRegulationBDisclaimer: 'We intend to apply for joint credit',
      communityPropertyDisclaimer:
        null,
      jointCreditDisclaimer: 'We intend to apply for joint credit'
    },
    qualificationTemplates: null,
    enableExperian: true,
    providerId: null,
    sceLeadSource: 'DSF',
    hideVoi: false,
    voiInceptionMiles: null,
    opptVehicleId: null,
    tradeInVehicleId: null,
    creditFormId: null,
  };

  public PreQualiFication: PreQualification = {
    siteId: 10000,
    microsoftLocaleId: 1033,
    sceId: null,
    sceUserId: null,
    sceVehicleOfInterestId: null,
    userId: null,
    buyer: {
      personalInformation: {
        firstName: null,
        lastName: null,
        middleName: null,
        phoneNumber: null,
        emailAddress: null,
        dateOfBirth: null,
        income: null,
        monthlyMortgage: null,
        currentAddress: {
          addressLine1: null,
          addressLine2: null,
          city: null,
          stateCode: null,
          postalCode: null,
          yearsAtAddress: null,
          monthsAtAddress: null,
        },
        previousAddress: []
      },
      financialInformation: {
        securityInformation: {
          dob: null,
          ssn: null,
          ssn1: null,
          ssn2: null,
          ssn3: null,
          dobMonth: null,
          dobDate: null,
          dobYear: null,
        },
        residenceInformation: {
          residenceType: null,
          monthlyMortgageAmount: null,
        },
        currentEmployer: {
          employmentStatus: null,
          jobType: null,
          employerName: null,
          jobTitle: null,
          phoneNumber: null,
          yearsAtEmployer: null,
          monthsAtEmployer: null,
          salary: null,
          frequency: null,
        },
        previousEmployer: {
          employmentStatus: null,
          jobType: null,
          employerName: null,
          jobTitle: null,
          phoneNumber: null,
          yearsAtEmployer: null,
          monthsAtEmployer: null,
          salary: null,
          frequency: null,
        },
        otherIncomeInformation: {
          amount: null,
          frequency: null,
          otherIncomeType: null,
        }
      },
      educationalInformation: null,
      consentIndicator: true,
      initials: null
    },
    voi: {
      vin: null,
      year: null,
      make: null,
      model: null,
      trim: null,
      stockType: null,
      hyperionId: null,
      chromeStyleId: null,
      isPrimary: false,
      stockNo: null,
      voiInceptionMiles: null,
      showVoiPreview: true,
      photo:
        null,
      ANPrice: null,
      InventoryStatus: null,
      Mileage: null,
    },
    disclaimers: {
      // tslint:disable-next-line: max-line-length
      preQualAgreement: 'I understand that by clicking on &nbsp;I AGREE, I am providing written instructions to AutoNation under the Fair Credit Reporting Act authorizing AutoNation to obtain information from my personal credit profile or other information from Experian. I authorize AutoNation to obtain such information solely to prequalify me for financing options.',
      // tslint:disable-next-line: max-line-length
      preQualifiedDisclaimer: '"This pre-qualified loan amount is only valid at any AutoNation Store. This offer is not guaranteed if you do not meet our criteria. Including providing acceptable property as collateral."',
      notQualifedDisclaimer: '',
      buyerAuthorization:
        null,
      coBuyerAuthorization:
        null,
      buyerRegulationBDisclaimer: 'We intend to apply for joint credit',
      coBuyerRegulationBDisclaimer: 'We intend to apply for joint credit',
      communityPropertyDisclaimer:
        null,
      jointCreditDisclaimer: 'We intend to apply for joint credit'
    },
    qualificationTemplates: {
      // tslint:disable-next-line: quotemark
      Qualified: "Congratulations [FirstName]! You're pre-qualified for a loan up to $[dollar_amount].",
      NotQualified: 'Thank you [FirstName]! Please provide us with a little more information so we can complete your request.'
    },
    enableExperian: true,
    providerId: null,
    sceLeadSource: null,
    hideVoi: false,
    voiInceptionMiles: null,
    opptVehicleId: null,
    tradeInVehicleId: null,
    creditFormId: null,
    vin: null,
    hyperianId: null,
    ymmtObj:null
  };

  public LegacyCreditApplication: CreditApplication =
  {
    creditAppId: "",
    opptId: "",
    viewType: 0,
    userName: "",
    buyer: {
      personalInformation: {
        firstName: "",
        lastName: "",
        middleName: "",
        phoneNumber: "",
        emailAddress: "",
        income: null,
        monthlyMortgage: null,
        currentAddress: {
          addressLine1: "",
          addressLine2: "",
          city: "",
          state: "",
          stateCode: "",
          postalCode: "",
          yearsAtAddress: 0,
          monthsAtAddress: 0
        },
        previousAddress: [
          {
            addressLine1: "",
            addressLine2: "",
            city: "",
            state: "",
            stateCode: "",
            postalCode: "",
            yearsAtAddress: 0,
            monthsAtAddress: 0
          }
        ],
        ssn: ""
      },
      financialInformation: {
        securityInformation: {
          dob: "",
          ssn: ""
        },
        residenceInformation: {
          monthlyMortgageAmount: 0,
          residence: 0
        },
        currentEmployer: {
          employerName: "",
          jobTitle: "",
          salary: 0,
          phoneNumber: "",
          employmentStatus: 0,
          job: 0,
          frequency: 0,
          yearsAtEmployer: 0,
          monthsAtEmployer: 0
        },
        previousEmployer: {
          employerName: "",
          jobTitle: "",
          salary: 0,
          phoneNumber: "",
          employmentStatus: 0,
          job: 0,
          frequency: 0,
          yearsAtEmployer: 0,
          monthsAtEmployer: 0
        },
        otherIncomeInformation: {
          otherIncome: "",
          frequency: 0,
          explain: "",
          amount: 0
        }
      },
      educationalInformation: null,
      consentIndicator: false,
      initials: ""
    },
    coBuyer :null,
    disclaimers: {
      preQualAgreement: "",
      preQualifiedDisclaimer: "",
      notQualifedDisclaimer: "",
      buyerAuthorization: "",
      coBuyerAuthorization: "",
      buyerRegulationBDisclaimer: "",
      coBuyerRegulationBDisclaimer: "",
      communityPropertyDisclaimer: ""
    },
    managerInitials: "",
    reasonForChange: "",
    shortForm: {
      tradeInInfo: {
        applyTrade: false,
        applyTradeFullValue: false,
        applyTradeAmount: 0,
        tradePayoff: 0,
        tradeValue: 0,
        missingTitle: false,
        openTradeDmvFees: 0,
        inServiceDate: null,
        inceptionMiles: 0
      },
      intendedUse: 0,
      paymentOption: 0,
      cashDown: 0,
      vehicleInformation: {
        vin: "",
        year: 0,
        make: "",
        model: "",
        trim: "",
        stockType: "",
        chromeStyleId: "",
        stockNo: "",
        hyperionId: "",
        inceptionMiles: 0
      },
      dealParameters: {
        paymentId: "",
        vehicleId: 0,
        tradeInVehicleId: 0
      },
      vehiclePayment: {
        bookValue: 0,
        bookValueSource: "",
        anPrice: 0,
        msrp: 0
      }
    },
    step: 0,
    coBuyerFullName: "",
    buyerFullName: ""
  };

  BuyNowHeadlessPrefix = '';
  LeadDetails$ =new BehaviorSubject<LeadDetails | null>(null);
  YMMTDetails$ = new BehaviorSubject<({make:'',year:'',model:'',trim:'',stockType:'',vehicleImage:''} | null)>(null);
  HyperionId$= new BehaviorSubject<(string | null)>(null);
  StoreDetails$ = new BehaviorSubject<(string | null)>(null);
  constructor(
    private http: HttpClient,
    public devModeService: DevModeService,
    private notificationService: NotificationsService,
    public ngxService: NgxUiLoaderService,
    @Inject('config') public config: IConfig,
  ) { }

  SaveCreditApp(
    creditApp: CreditApplication,
    SubPage?:any,
    showLoading = true
  ): Observable<CreditApplicationResponseType> {
    let url:any;
    if (showLoading) {
      this.ngxService.stopAllLoader('creditApplication');
      this.ngxService.startLoader('creditApplication'); // start foreground spinner of the master loader with 'default' taskId
      // Stop the foreground loading after 5s
    }
    if(SubPage?.toString().includes('credit-application')){
      url = '/' + SubPage + CREDITAPP_API_URLS.SAVE_CREDIT_APPLICATION;
     }else{
      const buynowCAHeadlessPrefix = this.config.Sitecore?.BuyNowHeadlessPrefix ? this.config.Sitecore?.BuyNowHeadlessPrefix : '';
      url = `${buynowCAHeadlessPrefix}${CREDITAPP_API_URLS.SAVE_CREDIT_APPLICATION}`;
    }

    if (creditApp.step > 1 && creditApp.step < 13) {
      url += '?retry';
    }

    if (this.devModeService.isDevMode()) {
      const mockedResponse: CreditApplicationResponseType = {
        isSuccess: true,
        additionalInfo: '',
        message: '',
        statusCode: 200
      };

      // const failedResponse = 'Backend returned code 500: [object Object]';
      this.notificationService.broadcastNotification({
        Message: 'Simulating submission for', Type: NotificationType.information, Payload: [creditApp, mockedResponse]
      });
      this.CreditApplication = creditApp;
      return of(mockedResponse as any).pipe(delay(3000), map(r => {
        try { this.ngxService.stopAllLoader('creditApplication'); } catch (e) { } return r;
      }));
      // url = 'http://instorelocal.autonation.com' + CREDITAPP_API_URLS.SAVE_CREDIT_APPLICATION;
    }

    return (
      this.http
        .post<CreditApplicationResponseType>(url, creditApp)
        // tslint:disable-next-line: arrow-return-shorthand
        .pipe(
          map(ca => {
            this.ngxService.stopAllLoader('creditApplication');
            /*this.CreditApplication = ca;*/
            if (ca.isSuccess && ca.data) {
              if(SubPage?.toString().includes('credit-application')){
                this.LegacyCreditApplication = creditApp;
                this.LegacyCreditApplication.creditAppId = ca.data.CreditAppId;
                this.LegacyCreditApplication.shortForm.dealParameters.creditAppId = ca.data.CreditAppId;
                this.LegacyCreditApplication.opptId = ca.data.OpptId;
                this.LegacyCreditApplication.creditApplicationStatus = CreditApplicationStatusTypeEnum[ca.data.CreditApplicationStatus];
              }
              else{
                this.CreditApplication = creditApp;
                this.CreditApplication.creditAppId = ca.data.creditAppId;
                this.CreditApplication.creditFormId = ca.data.creditFormId;
                this.CreditApplication.shortForm.dealParameters.creditAppId = ca.data.creditAppId;
                this.CreditApplication.shortForm.dealParameters.creditFormId = ca.data.creditFormId;
                this.CreditApplication.creditApplicationStatus = CreditApplicationStatusTypeEnum[ca.data.creditApplicationStatus];
              }
              this.notificationService.broadcastNotification({ Message: ca.message, Type: NotificationType.information, Payload: ca });
            } else {
              this.notificationService.broadcastNotification({ Message: ca.additionalInfo, Type: NotificationType.error, Payload: ca });
            }
            return ca;
          }),
          catchError(error => {
            try {
              this.ngxService.stopAllLoader('creditApplication');
              this.notificationService.broadcastNotification({ Message: 'error occured', Type: NotificationType.error, Payload: error });
            } catch (e) { }
            return of(error);
          })
        )
    );
  }

  SaveCreditAppAndForget(creditApp: CreditApplication) {
    this.SaveCreditApp(creditApp).subscribe(response => {
      this.notificationService.broadcastNotification({
        Type: NotificationType.information,
        Message: 'Credid App Saved:',
        Payload: response.isSuccess
      });
    });
  }

  GetCreditApp(
    creditAppRequest: CreditApplicationRequestType
  ): Observable<any> {
    this.ngxService.stopAllLoader('creditApplication');
    this.ngxService.startLoader('creditApplication'); // start foreground spinner of the master loader with 'default' taskId
    const buynowCAHeadlessPrefix = this.config.Sitecore?.BuyNowHeadlessPrefix ? this.config.Sitecore?.BuyNowHeadlessPrefix : '';
    const url = `${buynowCAHeadlessPrefix}${CREDITAPP_API_URLS.GET_CREDIT_APPLICATION}`;
    if (this.devModeService.isDevMode()) {
      const cloneCA = { ...CreditAppResponseMock };
      cloneCA.step = 1;
      return of({ IsSuccess: true, CreditApplication: cloneCA }).pipe(delay(1000), map(r => {
        try {
          this.ngxService.stopAllLoader('creditApplication');
          this.CreditApplication = r.CreditApplication;
        } catch (e) { }
        return r;
      }));
    }
    return this.http.post<any>(url, creditAppRequest).pipe(
      map(r => {
        this.ngxService.stopAllLoader('creditApplication');
        if (r.IsSuccess) {
          this.CreditApplication = r.CreditApplication;
        }
        return r;
      }),
      catchError(error => {
        try {
          this.ngxService.stopAllLoader('creditApplication');
          this.notificationService.broadcastNotification({ Message: 'error occured', Type: NotificationType.error, Payload: error });
        } catch (e) { }
        return of(error);
      })
    );
  }

  // getZipCodeInfo(request: IZipCodeRequest): Observable<IZipCodeResponse> {
  //   const url = CREDITAPP_API_URLS.Validate_ZipCode_API_URL;
  //   console.log('service request: ', request);
  //   // const requestObj = { ...request,
  //   //   __RequestVerificationToken: ( document.getElementsByName('__RequestVerificationToken')[0] as HTMLInputElement).value
  //   // };
  //   if (this.devModeService.isDevMode()) {
  //     // url = 'https://www6.qaautonation.com' + url;
  //     return of(ZipCodeResponseMock).pipe(delay(100));
  //   }
  //   // url = 'https://www5.qaautonation.com' + url;
  //   return this.http.post<IZipCodeResponse>(url, request);
  // }

  async validateZipCodeInfo(request: IZipCodeRequest) {
    return await this.getZipCodeInfo(request);

  }

  async getZipCodeInfo(request: IZipCodeRequest) {
    const zipcode = request.zipCode;
    let zipCodeResponse = {
      Success: false,
      ZipCodeData: null,
      ErrorCodes: []
    };
    const wnd = window as any;
    const location = await wnd.AN?.locationService?.getLocationByQuery(zipcode);
    if(location?.ValidPostalCode) {
      zipCodeResponse = {
        Success: true,
        ZipCodeData: {
          Latitude: location.Latitude,
          Longitude: location.Longitude,
          City: location.City || '',
          State: location.StateCode || '',
          StateCode: location.StateCode || '',          
        },
        ErrorCodes:[]
      };
    }
    else {
      zipCodeResponse.ErrorCodes.push('invalid zipcode');
    }
    return zipCodeResponse;
  }

  SendInfoToBank(
    creditApp: CreditApplication
  ): Observable<BankResponseType> {
    const url = BANK_API.ROUTEONE_URL;

    if (this.devModeService.isDevMode()) {
      const mockedResponse: BankResponseType = {
        isSuccess: true,
        additionalInfo: '',
        message: '',
        statusCode: 200
      };
      this.notificationService.broadcastNotification({
        Message: 'Simulating BANK submition for ' + url, Type: NotificationType.information, Payload: [creditApp, mockedResponse]
      });
      this.CreditApplication = creditApp;
      return of(mockedResponse).pipe(delay(4000));
    } else {
      // todo
    }
  }

  buyNowToggleNavigation() {
    try {
      if ((window as any).buynow.navigation.toggleNavigationDisableState) {
        (window as any).buynow.navigation.toggleNavigationDisableState();
      }
    } catch (e) {

    }
  }


  SavePreQualification(
    preQual: PreQualification,
    isBuyNow?: boolean,
  ): Observable<PreQualificationResponseType> {
    this.ngxService.stopAllLoader(`${isBuyNow ? 'creditApplicationPreQual' : 'creditApplication'}`);
    this.ngxService.startLoader(`${isBuyNow ? 'creditApplicationPreQual' : 'creditApplication'}`); // start foreground spinner of the master loader with 'default' taskId
    // Stop the foreground loading after 5s
    this.buyNowToggleNavigation();


    const url = `${this.BuyNowHeadlessPrefix}${CREDITAPP_API_URLS.SAVE_PREQUALIFICATION}`;


    if (this.devModeService.isDevMode()) {
      const mockedResponse: PreQualificationResponseType = {
        IsSuccess: true,
        StatusCode: 0,
        AdditionalInfo: null,
        Message: 'Short Form Submission Successful.',
        Data: {
          LeadResponse: {
            oppt_id: 76656019,
            appt_id: null,
            oppt_contact_id: 68138154,
            oppt_vehicle_id: 198391735,
            dst_oppt_id: null,
            HyperionId: 'NOSTORE'
          },
          PreQualifiedResponse: {
            PreQualifiedInformation: {
              Message: 'Thank you Anup! Please provide us with a little more information so we can complete your request.',
              PreQualifiedAmount: 0,
              SecureExperianResponse: null
            },
            DealParameters: {
              SceId: null,
              HyperionId: 'NOSTORE',
              SceUserId: null,
              SceVehicleOfInterestId: 0,
              UserId: null,
              CreditAppId: 'c2c4d2b7-245d-4802-94c1-41ba66d7e0ed',
              ParentCreditAppId: null,
              OpptId: 76656019,
              OpptVehicleId: 198391735,
              CreditShortFormId: null,
              CreditFormId: 'ebfe00d6-5e88-42c0-b373-5ddf1157dfef',
              TradeInVehicleId: null,
              PaymentCalculatorId: null,
              OpptContactId: '68138154'
            },
            LenderSubmissionStatus: 0,
            CreditApplicationStatus: 1,
            Success: true,
            ErrorCodes: [

            ]
          }
        }
      };

      this.notificationService.broadcastNotification({
        Message: 'Simulating submission for', Type: NotificationType.information, Payload: [preQual, mockedResponse]
      });
      this.PreQualiFication = preQual;
      return of(mockedResponse as any).pipe(delay(3000), map(r => {
        /* istanbul ignore next */
        try { this.ngxService.stopAllLoader('creditApplication'); } catch (e) { } return r;
      }));
      // url = 'http://instorelocal.autonation.com' + CREDITAPP_API_URLS.SAVE_CREDIT_APPLICATION;
    }

    return (
      this.http
        .post<PreQualificationResponseType>(url, preQual)
        // tslint:disable-next-line: arrow-return-shorthand
        .pipe(
          map(ca => {
            this.ngxService.stopAllLoader('creditApplication');
            this.buyNowToggleNavigation();
            return ca;
          }),
          catchError(error => {
            try {
              this.buyNowToggleNavigation();
              this.ngxService.stopAllLoader('creditApplication');
              this.notificationService.broadcastNotification({ Message: 'error occured', Type: NotificationType.error, Payload: error });
            } catch (e) { }
            return of(error);
          })
        )
    );
  }

  standAloneLeadTransactionHL(preQual: PreQualification, SubPage,apiDomain: any = ''): Observable<PreQualificationResponseType> {
    this.ngxService.stopAllLoader('creditApplication');
    this.ngxService.startLoader('creditApplication'); // start foreground spinner of the master loader with 'default' taskId
    // Stop the foreground loading after 5s
    this.buyNowToggleNavigation();
    let url = '';
    if(apiDomain != '') {
      url = `${apiDomain}${CREDITAPP_API_URLS.STAND_ALONE_LEAD_TRANSACTION}`;
    }else if(SubPage !==''){
        url = '/' + SubPage + CREDITAPP_API_URLS.STAND_ALONE_LEAD_TRANSACTION;
    } else{
      url = CREDITAPP_API_URLS.STAND_ALONE_LEAD_TRANSACTION;
    }
     

    return (
      this.http
        .post<PreQualificationResponseType>(url, preQual)
        // tslint:disable-next-line: arrow-return-shorthand
        .pipe(
          map(ca => {
            this.ngxService.stopAllLoader('creditApplication');
            this.buyNowToggleNavigation();
            let resObj: any;
            if(ca?.Data && ca.Data.LeadDetails){
              resObj = ca.Data.LeadDetails;
              resObj.PreQualifiedAmount = 0;
              if(ca.Data?.PreQualifiedResponse?.PreQualifiedInformation) {
                resObj.PreQualifiedAmount = ca.Data?.PreQualifiedResponse?.PreQualifiedInformation?.PreQualifiedAmount || 0;
              }
              this.LeadDetails$.next(resObj);
            }
            if(ca?.Data && ca.Data.LeadResponse){
              this.HyperionId$.next(ca.Data.LeadResponse.HyperionId);
            }
          if (SubPage?.toString().includes('credit-application') && ca.IsSuccess === false && ca.Data === null && ca.Message === 'Could not determine the store to use'){
            this.notificationService.broadcastNotification({ Message: ca.Message, Type: NotificationType.error, Payload: ca.Message });
          }
            return ca;
          }),
          catchError(error => {
            try {
              this.buyNowToggleNavigation();
              this.ngxService.stopAllLoader('creditApplication');
              this.notificationService.broadcastNotification({ Message: 'error occured', Type: NotificationType.error, Payload: error });
            } catch (e) { }
            return of(error);
          })
        )
    );
  }

  CreateBuyNowLead(request: BuyNowLead): Observable<BuyNowLeadResponse> {
    this.ngxService.stopAllLoader('creditApplicationPreQual');
    this.ngxService.startLoader('creditApplicationPreQual'); // start foreground spinner of the master loader with 'default' taskId
    // Stop the foreground loading after 5s
    this.buyNowToggleNavigation();
    const url = `${this.BuyNowHeadlessPrefix}${CREDITAPP_API_URLS.BUY_NOW_LEAD_SUBMISSION}`;
    const requestObj = new FormData();
    requestObj.append('FirstName', request.FirstName);
    requestObj.append('MiddleInitial', request.MiddleName);
    requestObj.append('LastName', request.LastName);
    requestObj.append('Phonenumber', request.Phone);
    requestObj.append('EmailAddress', request.Email);
    requestObj.append('Zipcode', request.Zipcode);
    requestObj.append('Vin', request.Vin);
    requestObj.append('City', request.City);
    requestObj.append('State', request.State);
    requestObj.append('Address', request.Address);
    requestObj.append('IsHomeDelivery', request.IsHomeDelivery ? 'true' : 'false');
    requestObj.append('IsVinInvalid', request.IsVinInvalid ? 'true' : 'false');
    /* istanbul ignore next */
    if (request.IsVinInvalid) {
      requestObj.append('Make', request.Make);
      requestObj.append('Model', request.Model);
      requestObj.append('Year', request.Year);
      requestObj.append('Trim', request.Trim);
    }


    requestObj.append('__RequestVerificationToken',
      (document.getElementsByName('__RequestVerificationToken')[0] as HTMLInputElement).value);
    if (this.devModeService.isDevMode()) {
      const mockedResponse = {
        Success: true,
        LeadId: 77584052,
        IsUpdate: true
      };

      this.notificationService.broadcastNotification({
        Message: 'Simulating submission for', Type: NotificationType.information, Payload: [requestObj, mockedResponse]
      });
      return of(mockedResponse as any).pipe(delay(3000), map(r => {
        try { /* this.ngxService.stopAllLoader('creditApplication'); */ } catch (e) { } return r;
      }));
    }
    return (
      this.http
        .post<BuyNowLeadResponse>(url, requestObj)
        // tslint:disable-next-line: arrow-return-shorthand
        .pipe(
          map(leadData => {

            //  this.ngxService.stopAllLoader('creditApplication');
            return leadData;
          }),
          catchError(error => {
            try {
              this.ngxService.stopAllLoader('creditApplication');
              this.buyNowToggleNavigation();
              this.notificationService.broadcastNotification({ Message: 'error occured', Type: NotificationType.error, Payload: error });
            } catch (e) { }
            return of(error);
          })
        )
    );
  }

}
